import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CoreConfigService } from '@core/services/config.service';

/** Réaffiche menu / navbar après les écrans d'inscription (layout « blank »). */
@Injectable({ providedIn: 'root' })
export class AppShellLayoutService {
  constructor(
    private readonly coreConfig: CoreConfigService,
    @Inject(DOCUMENT) private readonly document: Document
  ) {}

  restoreAfterAuthPages(): void {
    this.coreConfig.restoreMainShellIfNeeded();
    this.document.querySelectorAll('.sidenav-overlay').forEach((el) => el.remove());
    const root = this.document.querySelector('app-root');
    root?.classList.remove('blank-page');
    this.document.body.classList.remove('vertical-overlay-menu', 'menu-hide', 'menu-open');
    this.document.documentElement.classList.remove(
      'vertical-overlay-menu',
      'menu-hide',
      'menu-open'
    );
  }
}
